import { render, staticRenderFns } from "./IntegracaoGatewayForm.vue?vue&type=template&id=39b25c2f&scoped=true"
import script from "./IntegracaoGatewayForm.vue?vue&type=script&lang=js"
export * from "./IntegracaoGatewayForm.vue?vue&type=script&lang=js"
import style0 from "./IntegracaoGatewayForm.vue?vue&type=style&index=0&id=39b25c2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b25c2f",
  null
  
)

export default component.exports